<template>
  <div class="Nav">
    <div class="header">
      <div class="header_cont">
        <el-row :gutter="20" type="flex" justify="center" align="middle">
          <el-col :span="3" class="logo_img">
            <img src="../../../assets/images/home/user.png" alt="" class="leftimg" @click="toCenter" />
          </el-col>
          <el-col :span="16" class="logo_img">
            <img src="../../../assets/image/home/logo.png" alt class="logo" @click="tohome" />
          </el-col>
          <el-col :span="3" class="logo_img">
            <img v-show="openmenuShow" src="../../../assets/images/home/menu.png" alt="" class="rightimg"
              @click="openmenu" />
          </el-col>
        </el-row>
      </div>
    </div>
    <transition name="fade">
      <div class="menu" v-show="menushow">
        <el-menu :default-active="path" class="menu" :router="true" @select="handleSelect">
          <el-menu-item index="/">
            <span slot="title">首页</span>
          </el-menu-item>
          <el-menu-item index="/traincourse">
            <span slot="title">培训课程</span>
          </el-menu-item>
          <el-menu-item index="/catalog">
            <span slot="title">课程目录</span>
          </el-menu-item>
          <el-menu-item index="/guide">
            <span slot="title">考试指南</span>
          </el-menu-item>
          <el-menu-item index="/examination">
            <span slot="title">参加考试</span>
          </el-menu-item>
          <el-menu-item index="/certificate">
            <span slot="title">证书发放</span>
          </el-menu-item>
        </el-menu>
      </div>
    </transition>
    <div class="main">
      <router-view></router-view>
    </div>
    <!-- <div class="Suspended" @click="study" v-if="Suspendedshow">
      <p>前往<br />课程</p>
    </div> -->
    <!-- 支付弹框 -->
  </div>
</template>
<script>
  let _this
  export default {
    data() {
      return {
        menushow: false,
        path: '',
        studyed: false,
        loading: false,
        payRadio: '1',
        form: {},
        obj: {},
        redeemData: '',
        token: '',
        Suspendedshow: true,
        openmenuShow: false,
      }
    },
    created() {
      _this = this
      let r_path = _this.$route.path
      if (r_path.indexOf('register') < 0) {
        _this.openmenuShow = true
      }
      this.obj = this.$store.state.wps_user
      _this.Storage.setStorage('agent', _this.$route.params.agent)
      var Sus = this.$route
      if (
        Sus.name == 'MLogin' ||
        Sus.name == 'MRegister' ||
        Sus.name == 'MAgreement' ||
        Sus.name == 'MReset'
      ) {
        this.Suspendedshow = false
      } else {
        this.Suspendedshow = true
      }
    },
    mounted() {
      this.init()
    },
    watch: {
      $route(to) {
        if (
          to.name == 'MLogin' ||
          to.name == 'MRegister' ||
          to.name == 'MAgreement' ||
          to.name == 'MReset'
        ) {
          this.Suspendedshow = false
        } else {
          this.Suspendedshow = true
        }
      },
    },
    methods: {
      openmenu() {
        this.menushow = !this.menushow
        this.path = this.$route.path.substring(
          this.$route.path.lastIndexOf('/') + 1
        )
        if (this.path == '' || this.path == 'home') {
          this.path = '/'
        }
      },
      handleSelect() {
        this.menushow = false
      },
      toCenter() {
        if (this.$store.state.wps_user.mobile) {
          this.$router.push({ path: '/userinfo' })
        } else {
          this.$router.push({ path: '/login' })
        }
      },
      tohome() {
        this.$router.push({ path: '/' })
      },
      init() {
        document.addEventListener('click', e => {
          let thisClassName = e.target.className
          if (thisClassName != 'rightimg') {
            this.menushow = false
          }
        })
      },
    },
  }
</script>
<style lang="less" scoped>
  .Nav {
    /deep/.el-row {
      margin: 0px !important;
    }

    background-color: #ffffff;

    .header {
      padding: 5px 0;
      width: 100%;
      // position: fixed;
      z-index: 99;
      background-color: #ffffff;

      .tel {
        color: #fd4a29;
        font-weight: bold;
        vertical-align: middle;
      }

      box-shadow: 0 0 8px #ccc;
    }

    .header_cont {
      padding: 10px 0px 8px;

      .logo_img {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .leftimg,
      .rightimg {
        position: relative;
        top: 1px;
        width: 80% !important;
      }

      .logo {
        width: 70% !important;
      }
    }

    .menu {
      position: fixed;
      right: 0px;
      width: 28vw;
      z-index: 99;
      background-color: #fff;

      /deep/.el-menu-item {
        height: 40px;
        line-height: 40px;
        color: #333;
      }

      /deep/.el-menu-item:hover {
        background-color: #fff;
        color: #fd4a29;
      }

      /deep/.el-menu-item.is-active {
        color: #fd4a29;
        background-color: #fff;
      }
    }

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.5s;
    }

    .fade-enter,
    .fade-leave-to {
      opacity: 0;
    }
  }

  .Suspended {
    width: 50px;
    height: 50px;
    border: 1px solid #fd4a29;
    background-color: #fd4a29;
    border-radius: 50%;
    text-align: center;
    position: fixed;
    z-index: 50;
    bottom: 30px;
    right: 10px;

    p {
      margin-top: 8px;
      color: #ffffff;
      font-size: 12px;
    }
  }
</style>
<style>
  .message-logout {
    width: auto !important;
  }
</style>